import apiBaseUrl from './apiBaseUrl'
import store from '../store/store'
import { getAuthHeader } from './AuthHeaderBuilder'
import { logout } from './logout'

function uploadFile(xhr, file, endpoint){
  const formData = new FormData();
  formData.append('file', file, file.name);
  
  xhr.open('POST', apiBaseUrl + '/crm/' + endpoint)

  xhr.addEventListener("error", logout)

  const authHeader = getAuthHeader(store.getState().authorization.authToken)
  xhr.setRequestHeader(authHeader[0],authHeader[1])
  xhr.send(formData)
}

export { uploadFile }



// WEBPACK FOOTER //
// ./src/utils/fileUploader.js